module.exports = "https://cdn.thelire.com/ins/resource/pic_error.ee76175bc64a83d1a79adb5176cff916.png";